import 'firebase/auth'
import 'firebase/database'

import React from 'react'

import { useMutation } from '@apollo/client'
import firebase from 'firebase/app'

import { CREATE_USER } from './graphql/mutations'
import defaultUserImage from './images/default-user-image.jpg'

const provider = new firebase.auth.GoogleAuthProvider()

// Find these options in your Firebase console
firebase.initializeApp({
  apiKey: 'AIzaSyBNHSWVEZnKz-TQc1itdqSq_73GpI-85J4',
  authDomain: 'instagram-clone-1500.firebaseapp.com',
  projectId: 'instagram-clone-1500',
  storageBucket: 'instagram-clone-1500.appspot.com',
  messagingSenderId: '625119139516',
  appId: '1:625119139516:web:cb22991a70b9c0e22562b9',
  measurementId: 'G-LKG7NE5HWV'
})

export const AuthContext = React.createContext()

function AuthProvider({ children }) {
  const [authState, setAuthState] = React.useState({ status: 'loading' })
  const [createUser] = useMutation(CREATE_USER)

  React.useEffect(() => {
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        const token = await user.getIdToken()
        const idTokenResult = await user.getIdTokenResult()
        const hasuraClaim = idTokenResult.claims['https://hasura.io/jwt/claims']

        if (hasuraClaim) {
          setAuthState({ status: 'in', user, token })
        } else {
          // Check if refresh is required.
          const metadataRef = firebase
            .database()
            .ref(`metadata/${user.uid}/refreshTime`)

          metadataRef.on('value', async data => {
            if (!data.exists) return
            // Force refresh to pick up the latest custom claims changes.
            const token = await user.getIdToken(true)
            setAuthState({ status: 'in', user, token })
          })
        }
      } else {
        setAuthState({ status: 'out' })
      }
    })
  }, [])

  async function loginWithGoogle() {
    const data = await firebase.auth().signInWithPopup(provider)

    if (data.additionalUserInfo.isNewUser) {
      const { uid, displayName, email, photoURL } = data.user
      const username = `${displayName.replace(/\s+/g, '')}${uid.slice(-5)}`
      const variables = {
        userId: uid,
        name: displayName,
        username,
        email,
        bio: '',
        website: '',
        phoneNumber: '',
        profileImage: photoURL
      }

      await createUser({ variables })
    }
  }

  async function loginWithEmailAndPassword(email, password) {
    const data = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)

    return data
  }

  async function signUpWithEmailAndPassword(formData) {
    const data = await firebase
      .auth()
      .createUserWithEmailAndPassword(formData.email, formData.password)

    if (data.additionalUserInfo.isNewUser) {
      const variables = {
        userId: data.user.uid,
        name: formData.name,
        username: formData.username,
        email: data.user.email,
        bio: '',
        website: '',
        phoneNumber: '',
        profileImage: defaultUserImage
      }

      await createUser({ variables })
    }
  }

  async function signOut() {
    setAuthState({ status: 'loading' })
    await firebase.auth().signOut()
    setAuthState({ status: 'out' })
  }

  async function updateEmail(email) {
    await authState.user.updateEmail(email)
  }

  if (authState.status === 'loading') {
    return null
  } else {
    return (
      <AuthContext.Provider
        value={{
          signUpWithEmailAndPassword,
          authState,
          loginWithGoogle,
          signOut,
          loginWithEmailAndPassword,
          updateEmail
        }}
      >
        {children}
      </AuthContext.Provider>
    )
  }
}

export default AuthProvider
